import * as React from 'react';

export const Footer = () => {
  return (
    <div className="container flex-row justify-content-center  align-self-center mt-5">
      <footer className=" col-10 container-fluid   ">
        <div className="row pt-5 mb-4 ">
          <div className="col-4 ">
            <h2 className="h4 text-primary">Kapcsolat</h2>
          </div>
        </div>
        <div className="row justify-content-around">
          <div className="col-4  text-white text-start">
            <p>
              <i className="bi-telephone"></i> +36 1 850 6006
            </p>
          </div>
          <div className="col-4  text-white text-start">
            <p>
              <i className="bi-envelope"></i>{' '}
              <a className="text-white text-decoration-none" href="mailto:adrianaconnect@automatik.hu">
                adrianaconnect@automatik.hu
              </a>
            </p>
          </div>
          <div className="col-4  text-white text-start">
            <p>
              <a
                className="text-white text-decoration-none"
                href="https://www.automatik.hu/lib/doc/adriana_cookie_1.0.pdf"
              >
                Cookie használata
              </a>
            </p>
          </div>
        </div>
        <div className="row justify-content-around ">
          <div className="col-4  text-white ">
            <div className="flex-wrap flex-column">
              <div>
                <i className="bi-clock"></i>
                <span className="m-2">hétfőn: 12 - 16</span>
              </div>
              <div>
                keddtől - csütörtökig: 9:00-16:00 <br />
                péntek: 9:00-13:00
              </div>
            </div>
          </div>
          <div className="col-4  text-white text-start">
            <p>
              <i className="bi-facebook"></i>{' '}
              <a
                target="_blank"
                rel="noreferrer"
                className="text-white text-decoration-none"
                href="https://www.facebook.com/adriana.accounting/"
              >
                Adriana Facebook oldal
              </a>
            </p>
          </div>

          <div className="col-4 text-white text-start">
            <p>
              <a className="text-white text-decoration-none" href="https://adriana.hu/adatkezelesi-tajekoztato">
                Adatkezelési tájékoztató
              </a>
            </p>
          </div>
        </div>

        <div className="row mt-5">
          <div className="col-12 text-center text-white">
            Az Adriana Connect és a adrianaconnect.com szolgáltatója az Adriana Automatik Kft.
          </div>
        </div>
        <div className="row pb-4">
          <div className="col-12 text-center text-white">
            &copy; {new Date().getFullYear().toString()}, Minden jog fenntartva: Adriana Automatik Kft.
          </div>
        </div>
      </footer>
    </div>
  );
};
